import { useState, useEffect } from 'react';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useGetResolution886Report } from '@/hooks/v2/resolution-886';

export function useReviewsModal() {
	const [reportId, setReportId] = useState<string>('');
	const [isOpenModalReviews, setIsOpenModalReviews] = useState<boolean>(false);

	const { organization, company } = useApplicationContext();

	const { data } = useGetResolution886Report({
		organization_id: organization!.id,
		company_id: company!.id,
		id: reportId
	});

	function handleOpenModalReviews(params: any): void {
		setReportId(params.id);
	}

	function handleCloseModalReviews(): void {
		setReportId('');
		setIsOpenModalReviews(false);
	}

	useEffect(() => {
		if (data) {
			setIsOpenModalReviews(true);
		}
	}, [data]);

	return {
		report: data || null,
		isOpenModalReviews,
		handleOpenModalReviews,
		handleCloseModalReviews
	};
}
